export default "__VITE_ASSET__3bc1fbce__"